module.exports = __webpack_public_path__ + "img/popup-arrow.188eaab3.png";